import { useMediaQuery } from "react-responsive";

const useResponsive = () => {
  const isDesktop = useMediaQuery({ query: "(min-width: 1181px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 1180px)" });
  return { isDesktop, isTablet };
};
export default useResponsive;
